import React from 'react';
import Tile from "./Tile";
import TileGroup from "./TileGroup";

function SecondaryKeys(props) {
  const calc = props.calc;
  return (
    <TileGroup scndKey={true}>
      <Tile onClick={() => calc("setv1")} scndKey={true} size="small">S v<sub>1</sub></Tile>
      <Tile onClick={() => calc("recv1")} scndKey={true} size="small">R v<sub>1</sub></Tile>
      <Tile onClick={() => calc("setv2")} scndKey={true} size="small">S v<sub>2</sub></Tile>
      <Tile onClick={() => calc("recv2")} scndKey={true} size="small">R v<sub>2</sub></Tile>
      <Tile onClick={() => calc("exp")} scndKey={true}>e<sup>x</sup></Tile>
      <Tile onClick={() => calc("pw2")} scndKey={true}>2<sup>x</sup></Tile>
      <Tile onClick={() => calc("pw10")} scndKey={true}>10<sup>x</sup></Tile>
      <Tile onClick={() => calc("ln")} scndKey={true}>ln</Tile>
      <Tile onClick={() => calc("sin")} scndKey={true}>sin</Tile>
      <Tile onClick={() => calc("cos")} scndKey={true}>cos</Tile>
      <Tile onClick={() => calc("tan")} scndKey={true}>tan</Tile>
      <Tile onClick={() => calc("log")} scndKey={true} size="medium">log</Tile>
      <Tile onClick={() => calc("vert")} scndKey={true}><sup>1</sup>/<sub>x</sub></Tile>
      <Tile onClick={() => calc("sqrt")} scndKey={true} size="medium">√</Tile>
      <Tile onClick={() => calc("qrt")} scndKey={true} size="medium"><sup>3</sup>√</Tile>
      <Tile onClick={() => calc("rand")} scndKey={true} size="small">Rand</Tile>
      <Tile onClick={() => calc("e")} scndKey={true}>e</Tile>
      <Tile onClick={() => calc("pi")} scndKey={true}>π</Tile>
      <Tile onClick={() => calc("phi")} scndKey={true}>φ</Tile>
      <Tile onClick={() => calc("py")} scndKey={true} size="medium">√2</Tile>
    </TileGroup>
  );
}

export default SecondaryKeys;



// WEBPACK FOOTER //
// ./src/MDCCalc/SecondaryKeys.js